import MilestonesSerializer from './base';

export default class Level extends MilestonesSerializer {}
